import { ContatoService } from 'src/app/core/services/contato.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CountryModel } from 'src/app/shared/models/country.model';
import { CountryService } from 'src/app/core/services/country.service';
import { HeaderService } from '../../../../core/services/header.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SimpleModalComponent } from 'src/app/shared/modals/simple-modal/simple-modal.component';
import { Title, Meta } from '@angular/platform-browser';
import { MenuEnum } from 'src/app/shared/enum/menu-enum';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-revenda',
  templateUrl: './revenda.component.html',
  styleUrls: ['./revenda.component.scss']
})

export class RevendaComponent implements OnInit {
  formGroup: FormGroup;

  data: any;
  countrys: Array<CountryModel>;

  constructor(
    private translate: TranslateService,
    private countryService: CountryService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private contatoService: ContatoService,
    private modalService: NgbModal,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private gaService: GoogleAnalyticsService
  ) {

    this.carregarFormGroup();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
      this.carregarListaDePaises();
    });
  }

  ngOnInit() {
    this.headerService.carregarMenu(MenuEnum.REVENDA);
    this.carregarDados();
    this.carregarListaDePaises();
  }

  carregarFormGroup() {
    this.formGroup = this.formBuilder.group(
      {
        formNome: new FormControl('', Validators.required),
        formEmail: new FormControl('', Validators.compose(
          [
            Validators.required,
            Validators.email
          ]
        )),
        formTelefone: new FormControl('', [Validators.required, Validators.maxLength(18)]),
        formEmpresa: new FormControl('', Validators.required),
        formCargo: new FormControl(''),
        formPais: new FormControl('', Validators.required),
        formSobreEmpresa: new FormControl('', Validators.required)
      }
    );
  }

  carregarDados() {
    this.translate.get('PRINCIPAL.PAGES.REVENDA').subscribe(
      res => {
        this.data = res;
        this.titleService.setTitle(this.data.HEADER_TITLE);
        this.meta.updateTag({name: 'description', content: this.data.META_DESCRIPTION});
        this.meta.updateTag({name: 'keywords', content:  this.data.META_KEYWORDS});
        this.gaService.pageView(this.router.url);
      });
  }

  carregarListaDePaises() {
    this.countryService.carregarListaDePaises()
      .subscribe(
        res => {
          this.countrys = res;
        }
      );
  }

  onSubmit() {
    this.contatoService.cadastrarRevenda(
      this.formGroup.get('formNome').value,
      this.formGroup.get('formEmail').value,
      this.formGroup.get('formTelefone').value,
      this.formGroup.get('formEmpresa').value,
      this.formGroup.get('formCargo').value,
      this.formGroup.get('formPais').value,
      this.formGroup.get('formSobreEmpresa').value
    )
      .subscribe(
        res => {
          let message;
          if (res != null) {
            message = res;
          } else {
            message = this.data.MENSAGEM_SUCESSO;
          }
          const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
          modalRef.componentInstance.message = message;
          this.formGroup.reset();
        },
        err => {
          let message;
          if (err != null && err.error != null) {
            message = err.error;
          } else {
            message = this.data.MENSAGEM_ERRO;
          }
          const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
          modalRef.componentInstance.message = message;
          this.formGroup.reset();
        }
      );
  }

}
